import React from "react";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import { AnimatePresence, motion } from "framer-motion";
import type { TrayEntry } from "../../Hooks/useClipStatusRegistry";
import { TrackerCard } from "../TrackerCard";

type TrayShellProps = {
  entries: TrayEntry[];
  expanded: boolean;
  onToggleTray: () => void;
  onDismiss: (id: string) => void;
};

export const TrayShell = ({ entries, onDismiss }: TrayShellProps) => {
  if (entries.length === 0) return null;

  return (
    <TrayWrapper>
      <AnimatePresence initial={false}>
        {entries.map((entry) => {
          const key =
            entry.kind === "clips" ? "standalone-clips" : entry.montageId;

          const dismissAll = () => {
            if (entry.kind === "montage") {
              onDismiss(entry.montageId);
            }
            entry.timelines.forEach((t) => onDismiss(t.trackId));
          };

          return (
            <motion.div
              key={key}
              initial={{ x: 60, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 60, opacity: 0 }}
              transition={{ type: "spring", stiffness: 400, damping: 30 }}
            >
              <TrackerCard
                timelines={entry.timelines}
                montageId={
                  entry.kind === "montage" ? entry.montageId : undefined
                }
                onDismiss={dismissAll}
              />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </TrayWrapper>
  );
};

const TrayWrapper = styled(Flex)`
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
`;
